import { DownloadDetailedBreadcrumb } from '../DownloadDetailedBreadcrumb';

import './DownloadDetailedHeader.scss';

interface DownloadDetailedHeaderProps {
  artifact: string;
  description: string;
  isMobile: boolean;
}

export const DownloadDetailedHeader = ({
  artifact,
  description,
  isMobile,
}: DownloadDetailedHeaderProps) => (
  <div className="download-detailed-header">
    <div className="download-detailed-header__left">
      <DownloadDetailedBreadcrumb artifact={artifact} />
      <div className="download-detailed-header__left-container">
        <h1
          className="download-detailed-header__left-title"
          data-testid="download-detailed-header__title"
        >
          {artifact}
        </h1>
        <p
          className="download-detailed-header__left-description"
          data-testid="download-detailed-header__description"
        >
          {description}
        </p>
        {isMobile && (
          <p className="download-detailed-header__left-mobile-text">
            AirKey software can be downloaded on a desktop device.
          </p>
        )}
      </div>
    </div>
  </div>
);
